import type { NavigationGuardNext as Next, RouteLocationNormalized as Route } from 'vue-router';
import { StorageFactory } from '@/factories/storage.factory';

import { type RedirectQuery, routeFromRedirectQuery } from '@/router/utils/routeFromRedirectQuery';
import { Assertions } from '@/lib/assert';

const storage = StorageFactory('localStorage');
const routeKey = 'route';

/**
 * TODO: documentazione
 */
export function store(namespace: string) {
  return async (to: Route, _from: Route, next: Next): Promise<void> => {
    Assertions.defined(to.query.back, 'to.query.back');

    const { name, query, params } = await routeFromRedirectQuery(to.query as RedirectQuery);

    storage.setItem(`${namespace}/${routeKey}`, {
      name,
      query,
      params,
    });

    next();
  };
}

/**
 * TODO: documentazione
 */
export function restore(namespace: string) {
  return (): Route | string => {
    const route = storage.getItem<Route>(`${namespace}/${routeKey}`) || '/';
    storage.removeItem(`${namespace}/${routeKey}`);
    return route;
  };
}
